// extracted by mini-css-extract-plugin
export var aboveInput = "_nf-0";
export var actionButton = "_nf-5";
export var actionButtonContainer = "_nf-1";
export var actionIcon = "_nf-6";
export var aiInfoContainer = "_nf-2";
export var attachmentWrapper = "_nf-7";
export var bold = "_nf-3";
export var checkIcon = "_nf-8";
export var clickingRecipientBar = "_nf-11";
export var commentThreadSwitch = "_nf-a";
export var draftImage = "_nf-b";
export var draftImageContainer = "_nf-c";
export var draftImages = "_nf-e";
export var editButton = "_nf-g";
export var editor = "_nf-f";
export var editorContainer = "_nf-y";
export var editorErrorTooltipWrapper = "_nf-9";
export var headerDivider = "_nf-h";
export var icon = "_nf-i";
export var info = "_nf-j";
export var internal = "_nf-n";
export var internalDivider = "_nf-k";
export var internalMessage = "_nf-l";
export var messageInputCard = "_nf-m";
export var messageInputForm = "_nf-o";
export var messageInputFormInternal = "_nf-p";
export var options = "_nf-q";
export var publicMessageCustomer = "_nf-s";
export var publicMessageMerchant = "_nf-r";
export var removeImageButton = "_nf-d";
export var replyButtons = "_nf-t";
export var showSignatureButton = "_nf-u";
export var spinner = "_nf-v";
export var verticalButtonDivider = "_nf-4";
export var visibilitySelector = "_nf-w";
export var warning = "_nf-x";
export var wrappingText = "_nf-z";
export var writingInternalNoteTopBorder = "_nf-10";